import { render } from "./WareInReceive.vue?vue&type=template&id=08b2fe3a&scoped=true"
import script from "./WareInReceive.vue?vue&type=script&lang=js"
export * from "./WareInReceive.vue?vue&type=script&lang=js"

import "./WareInReceive.vue?vue&type=style&index=0&id=08b2fe3a&scoped=true&lang=css"
import "./WareInReceive.vue?vue&type=style&index=1&id=08b2fe3a&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b2fe3a"]])

export default __exports__